import React, { Component } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import DateBox from 'devextreme-react/date-box';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions';
import { LoadPanel } from 'devextreme-react/load-panel';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { SendEmailComponent } from '../Shared/SendEmailComponent'
const position = { of: '#historydiv' };

export class DailyJobCountComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenModal: false,
            isSubmited: false,
            isEmailSubmitted: false,
            loadPanelVisible: false,

            chkCustomerTypeSelection: "1",
            dropdownCustomerType: [],
            customerTypeId: 0,

            chkVehicleTypeSelection: "1",
            dropdownVehicleType: [],
            vehicleTypeId: 0,

            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",

            errors: {
                customerTypeId: '',
                vehicleTypeId: '',
            }
        }

        this.getVehicleType = this.getVehicleType.bind(this);
        this.handleVehicleTypeChange = this.handleVehicleTypeChange.bind(this);
        this.handleVehicleTypeSelectionChange = this.handleVehicleTypeSelectionChange.bind(this);

        this.getCustomerType = this.getCustomerType.bind(this);
        this.handleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
        this.handleCustomerTypeSelectionChange = this.handleCustomerTypeSelectionChange.bind(this);

        this.handleFromDateChanged = this.handleFromDateChanged.bind(this);
        this.handleToDateChanged = this.handleToDateChanged.bind(this);

        this.handleReportTypeSelectionChange = this.handleReportTypeSelectionChange.bind(this);

        this.downloadAccountPaymentTypeSummaryAsPdf = this.downloadAccountPaymentTypeSummaryAsPdf.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }

    showModal = async () => {
        try {
            this.setState({ isOpenModal: true });
        } catch (ex) {
            console.log(ex);
        }
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getVehicleType();
            await this.getCustomerType();
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {

        this.setState({ isOpenModal: false });
        await this.handleClearSearch();
    }

    async getVehicleType() {
        try {
            var newObject = new Object();
            const requestParams = getRequestParams('POST', newObject);
            const response = await fetch('vehicletype-api/vehicletype', requestParams);
            const data = await response.json();
            this.setState({
                dropdownVehicleType: data.apiVehicleType,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleVehicleTypeChange(selectedOption) {
        this.setState({ vehicleTypeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.rowIndex : 0), })
        this.state.errors["vehicleTypeId"] = "";
    }

    handleVehicleTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkVehicleTypeSelection: value, vehicleTypeId: 0 });
        this.state.errors["vehicleTypeId"] = "";
    }

    async getCustomerType() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('customer-type-api/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownCustomerType: data.customerType,
            });

        } catch (e) {
            console.log(e);
        }
    }

    handleCustomerTypeChange(selectedOption) {
        this.setState({ customerTypeId: (selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0), })
        this.state.errors["customerTypeId"] = "";
    }

    handleCustomerTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkCustomerTypeSelection: value, customerTypeId: 0 });
        this.state.errors["customerTypeId"] = "";
    }

    handleReportTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ chkReportTypeSelection: value });
    }

    handleFromDateChanged(event) {
        let fromDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ startDate: fromDateValue })
    }
    handleToDateChanged(event) {
        let toDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ endDate: toDateValue })
    }


    handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isEmailSubmitted: false,
            loadPanelVisible: false,

            chkCustomerTypeSelection: "1",
            customerTypeId: 0,

            chkVehicleTypeSelection: "1",
            vehicleTypeId: 0,

            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",

            errors: {
                customerTypeId: '',
                vehicleTypeId: '',
            }
        });
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.customerTypeId = "";

        if (this.state.chkCustomerTypeSelection === "2" && this.state.customerTypeId == 0) {
            formIsValid = false;
            errors.customerTypeId = "Please select customer type.";
        }

        if (this.state.chkVehicleTypeSelection === "2" && this.state.vehicleTypeId == 0) {
            formIsValid = false;
            errors.customerCode = "Please select vehicle type.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }
    async downloadAccountPaymentTypeSummaryAsPdf() {
        try {
            this.setState({
                isSubmited: true,
            });
            var RptHead = "";
            var strRecordSelection = "";
            var strCustomer_Type = "";
            var strVehicle_Type = "";
            var sDate = "";

            var fileName = "";

            var request = new Object();
            request.LocationId = Number(sessionStorage.getItem("session_locationId"));

            if (this.state.chkCustomerTypeSelection === "1") {
                strCustomer_Type = " For all customer type, ";
            } else {
                let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);

                if (this.state.chkReportTypeSelection === "1") {
                    strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " Or " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.ACCT_TYPE} = '" + customerType.name + "')";
                }
                else {
                    strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " Or " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.ACCT_TYPE} = '" + customerType.name + "')";
                }
                strCustomer_Type = "  " + "For customer type" + "  " + customerType.name + ",";
            }

            if (this.state.chkVehicleTypeSelection === "1") {
                strVehicle_Type = " For all vehicle type, ";
            } else {
                let customerType = this.state.dropdownVehicleType.find(opt => opt.rowIndex == this.state.vehicleTypeId);

                if (this.state.chkReportTypeSelection === "1") {
                    strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " AND " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.CHARTER_TYPE} = '" + customerType.vehicleTypeCode + "')";
                }
                else {
                    strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " AND " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.CHARTER_TYPE} = '" + customerType.vehicleTypeCode + "')";
                }
                strVehicle_Type = "  " + "For vehicle type" + "  " + customerType.apiVehicleTypeDescription + ",";
            }


            request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
            request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";
            sDate = " From Date " + "  " + formatDate(this.state.startDate, "MM/dd/yyyy") + "  " + "  To Date " + formatDate(this.state.endDate, "MM/dd/yyyy");

            if (this.state.chkReportTypeSelection === "1") {
                fileName = "DailyJobCountSummary";
            } else {
                fileName = "DailyJobCountDetails";
            }

            RptHead = RptHead + strCustomer_Type;
            RptHead = RptHead + strVehicle_Type;
            RptHead = RptHead + sDate;

            request.Header = RptHead;
            request.MethodName = "GetDailyJobCount";
            request.ReportType = parseInt(this.state.chkReportTypeSelection);
            request.SelectionCrieteria = strRecordSelection;

            request.fileFormat = 'pdf';
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('crystal-report-api', requestParams);
            const dataResponse = await response.json();
            this.setState({
                isSubmited: false,
            });

            let a = document.createElement('a');
            a.href = dataResponse.reportBase64String;
            a.download = fileName + '.pdf';

            a.click();
        } catch (e) {
            this.setState({
                isSubmited: false,
            });
            console.log(e)
        }
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                var RptHead = "";
                var strRecordSelection = "";
                var strCustomer_Type = "";
                var strVehicle_Type = "";
                var sDate = "";

                var fileName = "";

                var request = new Object();
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));

                if (this.state.chkCustomerTypeSelection === "1") {
                    strCustomer_Type = " For all customer type, ";
                } else {
                    let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);

                    if (this.state.chkReportTypeSelection === "1") {
                        strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " Or " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.ACCT_TYPE} = '" + customerType.name + "')";
                    }
                    else {
                        strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " Or " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.ACCT_TYPE} = '" + customerType.name + "')";
                    }
                    strCustomer_Type = "  " + "For customer type" + "  " + customerType.name + ",";
                }

                if (this.state.chkVehicleTypeSelection === "1") {
                    strVehicle_Type = " For all vehicle type, ";
                } else {
                    let customerType = this.state.dropdownVehicleType.find(opt => opt.rowIndex == this.state.vehicleTypeId);

                    if (this.state.chkReportTypeSelection === "1") {
                        strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " AND " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.CHARTER_TYPE} = '" + customerType.vehicleTypeCode + "')";
                    }
                    else {
                        strRecordSelection = strRecordSelection + (strRecordSelection.length > 0 ? " AND " : "").toString() + "( {Proc_Vehicle_Type_Pax_Details;1.CHARTER_TYPE} = '" + customerType.vehicleTypeCode + "')";
                    }
                    strVehicle_Type = "  " + "For vehicle type" + "  " + customerType.apiVehicleTypeDescription + ",";
                }


                request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
                request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";
                sDate = " From Date " + "  " + formatDate(this.state.startDate, "MM/dd/yyyy") + "  " + "  To Date " + formatDate(this.state.endDate, "MM/dd/yyyy");

                if (this.state.chkReportTypeSelection === "1") {
                    fileName = "DailyJobCountSummary";
                } else {
                    fileName = "DailyJobCountDetails";
                }

                RptHead = RptHead + strCustomer_Type;
                RptHead = RptHead + strVehicle_Type;
                RptHead = RptHead + sDate;

                request.Header = RptHead;
                request.MethodName = "GetDailyJobCount";
                request.ReportType = parseInt(this.state.chkReportTypeSelection);
                request.SelectionCrieteria = strRecordSelection;

                request.fileFormat = 'pdf';
                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Daily Job Count';
                    let attachments = [];
                    let file = new Object();
                    file.fileData = fileData;
                    file.fileName = fileName + '.pdf';
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
            console.log(ex);
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '40%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit}
                        style={(this.state.isSubmited || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Daily Job Count</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="allCustomerType" value="1" checked={this.state.chkCustomerTypeSelection === "1"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">All Customer Type</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="singleCustomerType" value="2" checked={this.state.chkCustomerTypeSelection === "2"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">Single Customer Type</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownCustomerType.length > 0 ? this.state.dropdownCustomerType : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer type"
                                            name="customerTypeId"
                                            defaultValue={0}
                                            value={this.state.customerTypeId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleCustomerTypeChange}
                                            showClearButton={true}
                                            disabled={this.state.chkCustomerTypeSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["customerTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["customerTypeId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllVehicleType" value="1" checked={this.state.chkVehicleTypeSelection === "1"} onChange={this.handleVehicleTypeSelectionChange} />
                                            <label className="form-check-label">All Vehicle Type</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleVehicleType" value="2" checked={this.state.chkVehicleTypeSelection === "2"} onChange={this.handleVehicleTypeSelectionChange} />
                                            <label className="form-check-label">Single Vehicle Type</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownVehicleType.length > 0 ? this.state.dropdownVehicleType : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select vehicle type"
                                            name="vehicleTypeId"
                                            defaultValue={0}
                                            value={this.state.vehicleTypeId}
                                            displayExpr='apiVehicleTypeDescription'
                                            valueExpr='rowIndex'
                                            onSelectionChanged={this.handleVehicleTypeChange}
                                            showClearButton={true}
                                            disabled={this.state.chkVehicleTypeSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["vehicleTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["vehicleTypeId"]}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label>From Date</label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="fromDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.startDate}
                                            value={this.state.startDate}
                                            onValueChanged={this.handleFromDateChanged}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label>To Date</label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="toDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.endDate}
                                            value={this.state.endDate}
                                            onValueChanged={this.handleToDateChanged}
                                            width="100%"
                                            disabled={false}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Report Type</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSummary" value="1" checked={this.state.chkReportTypeSelection === "1"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Summary</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdDetails" value="2" checked={this.state.chkReportTypeSelection === "2"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Details</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="button" className="btn btn-success btn-sm" title="Download" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Search"><i className="fas fa-file-download"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}